import i18next from "i18next";
export default function (val, divideInteger) {
    return new Intl.NumberFormat(i18next.language, {
        style: "decimal"
    }).format(divideInteger ? val / 100 : val);
}
